module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.getProfileHaveClient) ? _c('v-flex', [_c('v-card', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md8": ""
    }
  }, [_c('v-client-page', {
    attrs: {
      "mode": 'mainPage',
      "itemId": _vm.profile.clientInn
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('v-container', {
    staticStyle: {
      "min-height": "0"
    },
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-flex', [_c('v-card', {
    attrs: {
      "to": "/doc_list/root",
      "color": "grey lighten-4"
    }
  }, [_c('v-card-title', {
    staticClass: "title",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("\n              Депозитарий\n            ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n            Сервис позволяет задепонировать документы и гарантирует что документы были опубликованы именно в том виде в каком они существуют. Вы можете ссылаться на задепонированные документы и использовать их для разрешения спорных ситуаций\n            ")])], 1)], 1), _vm._v(" "), _c('v-flex', [_c('v-card', {
    attrs: {
      "to": "/chats/root",
      "color": "grey lighten-4"
    }
  }, [_c('v-card-title', {
    staticClass: "title",
    attrs: {
      "primary-title": ""
    }
  }, [_c('v-badge', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.counters.notReviewedChats > 0),
      expression: "counters.notReviewedChats > 0"
    }],
    attrs: {
      "right": ""
    }
  }, [_c('span', {
    attrs: {
      "slot": "badge"
    },
    slot: "badge"
  }, [_vm._v(_vm._s(_vm.counters.notReviewedChats))]), _vm._v(" "), _c('span', [_vm._v("Сообщения")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.counters.notReviewedChats || _vm.counters.notReviewedChats === 0),
      expression: "!counters.notReviewedChats || counters.notReviewedChats === 0"
    }]
  }, [_vm._v("Сообщения")])], 1), _vm._v(" "), _c('v-card-text', [_vm._v("\n            Сервис позволяет обмениваться сообщениями, как и многие другие сервисы. Отличие Системы \"АТЛАНТ-СМАРТ\" в том, что вся переписка хранится в надежной базе Системы \"АТЛАНТ-СМАРТ\" и может быть использована для решения спорных ситуаций.\n            ")])], 1)], 1), _vm._v(" "), _c('v-flex', [_c('v-card', {
    attrs: {
      "to": "/monitoring_page",
      "color": "grey lighten-4"
    }
  }, [_c('v-card-title', {
    staticClass: "title",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("\n              Мониторинг контрагентов\n            ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n            Сервис позволяет отслеживать изменения, которые вносятся в ЕГРЮЛ вашими контрагентами. Это позволяет избежать сюрпризов и быть в курсе об изменениях, происходящих у Ваших партнеров.\n            ")])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.getProfileHaveClient) ? _c('v-flex', [_c('v-home-panel')], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f02b000","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MainPage.vue
// module id = 1142
// module chunks = 1